import { ContentType } from "../../../enums/contentStack.js";
import { getConfigurationSettingByDeveloperKey } from "../../../services/content/business.lib.js";
const getFSAConfig = async (locale) => {
  try {
    const data = await getConfigurationSettingByDeveloperKey(
      ContentType.ModuleSettings,
      "fsaEligibleInfoModal",
      locale
      //lang
    );
    return data;
  } catch (err) {
    console.error(
      "An error occured while fetching the FSAEligibleInfo module from ContentStack:",
      err
    );
    return null;
  }
};
export {
  getFSAConfig
};
